import { render } from "./right-content.vue?vue&type=template&id=62b606e3"
import script from "./right-content.vue?vue&type=script&lang=ts"
export * from "./right-content.vue?vue&type=script&lang=ts"
script.render = render

export default script